import { SidePanelProps } from '@mews/b2b-ui';
import { lt } from '@mews/framework';
import { ModalSidePanel } from '@mews-commander/ui';
import { AddNoteContainer, NotesContent, NotesContentProps } from './components';

type NotesContainerProps = Pick<SidePanelProps, 'opened' | 'onClose'> & Partial<NotesContentProps>;
export const NotesContainer = ({ onClose, opened, reservationId, accountsRecord, ...props }: NotesContainerProps) => (
    <ModalSidePanel
        opened={opened}
        onClose={onClose}
        title={lt('Notes')}
        headerActions={null}
        width="small"
        actions={
            accountsRecord && reservationId ? (
                <AddNoteContainer accountsRecord={accountsRecord} reservationId={reservationId} />
            ) : null
        }
        content={
            reservationId && accountsRecord ? (
                <NotesContent reservationId={reservationId} accountsRecord={accountsRecord} {...props} />
            ) : null
        }
    />
);
